var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoRecord(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 287,
    height: 287,
    viewBox: "0 0 287 287",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.c{fill:#febf2c;}.a{opacity:0.1;}.b{fill:#fff;}.d{fill:#3a3a3a;font-size:18px;font-family:Roboto-Medium, Roboto;font-weight:500;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-577 -381)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 143.5,
    cy: 143.5,
    r: 143.5,
    transform: "translate(577 381)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M22950.781,14760.022l-58.736,1.081-24.652,20.85,48.734,22.521,55.045-16.483,1.662-8Z",
    transform: "translate(-22201 -14264)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-17853 -17912)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -17)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M82.823,4V.012l23.992,20.012-5.558.127ZM-2.17,20.023,21.822.012V0h61V4h-61L3.388,20.15Z",
    transform: "translate(18521.178 18424)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M103,63H6a6.007,6.007,0,0,1-6-6V23H36v5a9.01,9.01,0,0,0,9,9H64a9.01,9.01,0,0,0,9-9V23h36V57A6.007,6.007,0,0,1,103,63Z",
    transform: "translate(18519 18421)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M42,17.034,52.607,6.428l3.535,3.535L45.535,20.57ZM0,9.963,3.535,6.428,14.142,17.034l-3.535,3.535ZM24.573,19V4h5V19Z",
    transform: "translate(18546.428 18366)"
  })), /*#__PURE__*/React.createElement("text", {
    className: "d",
    transform: "translate(726 595)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -67.715,
    y: 0
  }, "No record found!")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoRecord);
export default __webpack_public_path__ + "static/media/no-record.1c9a9c0135388b7bf11d3a9a75733a8b.svg";
export { ForwardRef as ReactComponent };